import React, { useState } from "react";

const QuoteIcon = () => (
  <svg width="36" height="36" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h4v10h-10z" fill="currentColor"/>
  </svg>
);

const CloseIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const TestimonialCard = ({ image, name, caption, onClick }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      style={{
        width: "280px",
        borderRadius: "16px",
        overflow: "hidden",
        boxShadow: isHovered 
          ? "0px 12px 32px rgba(16, 121, 136, 0.2)" 
          : "0px 6px 20px rgba(0, 0, 0, 0.08)",
        padding: "28px",
        display: "flex",
        flexDirection: "column",
        gap: "20px",
        justifyContent: "space-between",
        backgroundColor: "#ffffff",
        transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
        cursor: "pointer",
        minHeight: "220px",
        position: "relative",
        border: isHovered ? "2px solid #107988" : "2px solid transparent",
        transform: isHovered ? "translateY(-8px) scale(1.02)" : "translateY(0) scale(1)",
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={onClick}
    >
      {/* Animated background gradient */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          height: "4px",
          background: "linear-gradient(90deg, #107988, #20B2AA, #48CAE4)",
          transform: isHovered ? "scaleX(1)" : "scaleX(0)",
          transformOrigin: "left",
          transition: "transform 0.3s ease-out",
        }}
      />
      
      <div style={{ 
        color: "#107988", 
        opacity: isHovered ? 0.4 : 0.2,
        transition: "opacity 0.3s ease"
      }}>
        <QuoteIcon />
      </div>
      
      <p style={{ 
        fontSize: "16px", 
        color: "#545454", 
        lineHeight: "1.7",
        flex: 1,
        margin: "0",
        overflow: "hidden",
        display: "-webkit-box",
        WebkitLineClamp: "4",
        WebkitBoxOrient: "vertical",
        textOverflow: "ellipsis",
        fontWeight: "400"
      }}>
        {caption}
      </p>
      
      {/* Read more indicator */}
      <div style={{
        fontSize: "14px",
        color: "#107988",
        fontWeight: "600",
        opacity: isHovered ? 1 : 0.7,
        transition: "opacity 0.3s ease",
        display: "flex",
        alignItems: "center",
        gap: "4px"
      }}>
        Click to read full testimonial
        <span style={{ 
          transform: isHovered ? "translateX(4px)" : "translateX(0)",
          transition: "transform 0.3s ease"
        }}>→</span>
      </div>
      
      <div
        style={{
          justifyContent: "flex-start",
          alignItems: "center",
          flexDirection: "row",
          display: "flex",
          padding: "16px 0px 0px 0px",
          gap: "16px",
          borderTop: "1px solid #f0f0f0",
          marginTop: "auto"
        }}
      >
        <div style={{ position: "relative" }}>
          <img
            style={{
              width: "56px",
              height: "56px",
              objectFit: "cover",
              borderRadius: "50%",
              backgroundColor: "#f3f3f3",
              border: "3px solid #ffffff",
              boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
              transition: "transform 0.3s ease"
            }}
            src={image}
            alt={name}
          />
          <div style={{
            position: "absolute",
            bottom: "2px",
            right: "2px",
            width: "16px",
            height: "16px",
            backgroundColor: "#10B981",
            borderRadius: "50%",
            border: "2px solid white",
            transform: isHovered ? "scale(1.2)" : "scale(1)",
            transition: "transform 0.3s ease"
          }} />
        </div>
        <div>
          <p
            style={{
              fontSize: "18px",
              fontWeight: "700",
              lineHeight: "1.4",
              color: "#107988",
              margin: "0 0 2px 0"
            }}
          >
            {name}
          </p>
          <p style={{
            fontSize: "14px",
            color: "#888",
            margin: "0",
            fontWeight: "500"
          }}>
            Verified Client
          </p>
        </div>
      </div>
    </div>
  );
};

const TestimonialModal = ({ isOpen, onClose, testimonial }) => {
  if (!isOpen || !testimonial) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.6)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
        padding: "20px",
        backdropFilter: "blur(8px)",
        animation: "fadeIn 0.3s ease-out"
      }}
      onClick={onClose}
    >
      <div
        style={{
          backgroundColor: "white",
          borderRadius: "24px",
          padding: "40px",
          maxWidth: "600px",
          width: "100%",
          maxHeight: "80vh",
          overflow: "auto",
          position: "relative",
          boxShadow: "0px 20px 60px rgba(0, 0, 0, 0.3)",
          animation: "slideUp 0.3s cubic-bezier(0.4, 0, 0.2, 1)"
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          style={{
            position: "absolute",
            top: "20px",
            right: "20px",
            background: "#f3f4f6",
            border: "none",
            borderRadius: "50%",
            width: "40px",
            height: "40px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            color: "#6b7280",
            transition: "all 0.2s ease",
            zIndex: 1001
          }}
          onMouseOver={(e) => {
            e.target.style.backgroundColor = "#e5e7eb";
            e.target.style.color = "#374151";
          }}
          onMouseOut={(e) => {
            e.target.style.backgroundColor = "#f3f4f6";
            e.target.style.color = "#6b7280";
          }}
        >
          <CloseIcon />
        </button>

        <div style={{ 
          color: "#107988", 
          marginBottom: "24px",
          opacity: 0.3
        }}>
          <QuoteIcon />
        </div>

        <p style={{
          fontSize: "20px",
          lineHeight: "1.7",
          color: "#374151",
          marginBottom: "32px",
          fontWeight: "400",
          fontStyle: "italic"
        }}>
          "{testimonial.caption}"
        </p>

        <div style={{
          display: "flex",
          alignItems: "center",
          gap: "20px",
          paddingTop: "24px",
          borderTop: "2px solid #f0f0f0"
        }}>
          <img
            style={{
              width: "72px",
              height: "72px",
              objectFit: "cover",
              borderRadius: "50%",
              border: "4px solid #107988",
              boxShadow: "0px 6px 16px rgba(16, 121, 136, 0.2)"
            }}
            src={testimonial.image}
            alt={testimonial.name}
          />
          <div>
            <h3 style={{
              fontSize: "24px",
              fontWeight: "700",
              color: "#107988",
              margin: "0 0 4px 0"
            }}>
              {testimonial.name}
            </h3>
            <p style={{
              fontSize: "16px",
              color: "#6b7280",
              margin: "0",
              fontWeight: "500"
            }}>
              Verified Client • ComeToBe Coaching
            </p>
          </div>
        </div>
      </div>

      <style jsx>{`
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        
        @keyframes slideUp {
          from { 
            opacity: 0;
            transform: translateY(40px) scale(0.95);
          }
          to { 
            opacity: 1;
            transform: translateY(0) scale(1);
          }
        }
      `}</style>
    </div>
  );
};

const InteractiveTestimonials = () => {
  const [selectedTestimonial, setSelectedTestimonial] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const testimonials = [
    {
      image: "https://img1.wsimg.com/isteam/ip/fede63ad-1e58-4f64-9dfc-1618f05f64c1/Gunmeet_Singh_Banga_People_Advisory_Services_E.png/:/cr=t:0%25,l:0%25,w:100%25,h:100%25/rs=w:600,h:600,cg=true",
      name: "Gunmeet Singh Banga",
      caption: "My experience of working with Sunil (Come To Be Coaching) has been nothing short of extraordinary. His professional and personalized approach to coaching has greatly augmented my growth and development. His ability to engage fully in every conversation has enabled me to realize my true potential. I would highly recommend CTB if you're ready for a powerful mindset shift, aiming to become a more empowered individual and an effective coach."
    },
    {
      image: "https://img1.wsimg.com/isteam/ip/fede63ad-1e58-4f64-9dfc-1618f05f64c1/Grishma_Patel_Professional_Coach.png/:/cr=t:0%25,l:0%25,w:100%25,h:100%25/rs=w:600,h:600,cg=true",
      name: "Grishma Patel",
      caption: "My level 2 'Masterful Coach' training for PCC with ComeToBe has enhanced my skills and created a lasting impact on me as an individual. The program is very well crafted focusing on various tools, techniques, & competencies that assist in transitioning from ACC to PCC level. Experienced coaches & facilitators like Sunil & Prasad complimented each others styles covering a wide spectrum of learning styles making the entire process intriguing and fun."
    },
    {
      image: "https://img1.wsimg.com/isteam/ip/fede63ad-1e58-4f64-9dfc-1618f05f64c1/s-venkatakrishnan-head-hr-gbs-private-limited.png/:/cr=t:5.36%25,l:5.36%25,w:89.29%25,h:89.29%25/rs=w:600,h:600,cg=true,m",
      name: "S. Venkat",
      caption: "Working with Sunil was a pleasure, and I have immensely benefited from his professional and highly personalised approach to coaching. He brings tremendous value to coaching with his focus and being present in every conversation and enable clients to realise their potential. Sunil facilitates clients that the desired impact has been achieved, as measured through observable shifts in behaviours and mindsets."
    }
  ];

  const handleCardClick = (testimonial) => {
    setSelectedTestimonial(testimonial);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedTestimonial(null);
  };

  return (
    <div style={{
      padding: "40px 20px",
      // backgroundColor: "#f8fafc",
      minHeight: "100vh"
    }}>
      <div style={{
        maxWidth: "1200px",
        margin: "0 auto",
        textAlign: "center",
        marginBottom: "48px"
      }}>
        <h2 style={{
          fontSize: "36px",
          fontWeight: "800",
          color: "#107988",
          marginBottom: "16px",
          background: "linear-gradient(135deg, #107988, #20B2AA)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          backgroundClip: "text"
        }}>
          Client Testimonials
        </h2>
        <p style={{
          fontSize: "18px",
          color: "#6b7280",
          maxWidth: "600px",
          margin: "0 auto",
          lineHeight: "1.6"
        }}>
          Discover how our coaching has transformed lives. Click on any testimonial to read the full story.
        </p>
      </div>

      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "30px",
          justifyContent: "center",
          alignItems: "stretch"
        }}
      >
        {testimonials.map((testimonial, index) => (
          <TestimonialCard
            key={index}
            image={testimonial.image}
            name={testimonial.name}
            caption={testimonial.caption}
            onClick={() => handleCardClick(testimonial)}
          />
        ))}
      </div>

      <TestimonialModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        testimonial={selectedTestimonial}
      />
    </div>
  );
};

export default InteractiveTestimonials;